export interface Node { id: string; parent_id: string | null }
export const MAX_DEPTH = 3;

export function depthOf(id: string, nodes: Node[]): number {
  const byId = new Map(nodes.map(n => [n.id, n]));
  let d = 0; let cur: string | null = id;
  while (cur && byId.has(cur)) { d += 1; cur = byId.get(cur)!.parent_id; if (d > 1000) break; }
  return d;
}

export function isDescendant(candidate: string, root: string, nodes: Node[]): boolean {
  if (candidate === root) return true;
  const byId = new Map(nodes.map(n => [n.id, n]));
  const visited = new Set<string>();
  let cur: string | null = candidate;

  while (cur && byId.has(cur) && !visited.has(cur)) {
    if (cur === root) return true;
    visited.add(cur);
    cur = byId.get(cur)!.parent_id;
  }
  return false;
}

export function subtreeIds(rootId: string, nodes: Node[]): string[] {
  if (!nodes.some(n => n.id === rootId)) return [];
  const children = new Map<string, string[]>();
  for (const n of nodes) {
    if (!n.parent_id) continue;
    const arr = children.get(n.parent_id) ?? [];
    arr.push(n.id); children.set(n.parent_id, arr);
  }

  const out: string[] = [];
  const visited = new Set<string>();
  const stack = [rootId];

  while (stack.length) {
    const id = stack.pop()!;
    if (visited.has(id)) continue;
    visited.add(id);
    out.push(id);

    for (const c of (children.get(id) ?? [])) {
      if (!visited.has(c)) stack.push(c);
    }
  }
  return out;
}
